// extracted by mini-css-extract-plugin
module.exports = {"requestBox":"style_request-box__KheeW","mainAdornment":"style_main-adornment__Z0JKt","imageAdornment":"style_image-adornment__Gaslv"};